import { createContext, useState } from "react";

import ApiService from "../_services/ApiService";

export const LessonPlanContext = createContext({
  getAllLessonPlans: () => {},
  getLessonPlanById: () => {},
  getLessonSteps: ()=>{}
});

export const LessonPlanProvider = ({ children }) => {
  const [lessonPlans, setLessonPlans] = useState({
    lessons: [],
    error: null,
  });

  const [lessonSteps, setLessonSteps] = useState({});

  const fetchLessonPlans = async (typeId, subTypeId) => {
    let lessonPlanValue = {};

    try {
      const enquiryId = localStorage.getItem("enquiryId");
      const lessonPlansData = await ApiService.fetchGoldenStudyResources({
        enquiryId: parseInt(enquiryId),
        resourceTypeId: parseInt(typeId),
        resourceSubTypeIds: subTypeId,
        page: 0,
      });
      const resources = lessonPlansData.data?.data || [];

      if (resources.length) {
        lessonPlanValue = {
          lessons: resources,
          error: null,
        };
      }
    } catch (error) {
      console.log(error);

      lessonPlanValue = {
        lessons: [],
        error,
      };
    }

    setLessonPlans(lessonPlanValue);
    return lessonPlanValue;
  };

  const getAllLessonPlans = async (typeId, subTypeId) => {
    if (lessonPlans.lessons.length) {
      return lessonPlans.lessons;
    }

    const { lessons, error } = await fetchLessonPlans(typeId, subTypeId);

    if (error) return [];

    return lessons;
  };

  const getLessonPlanById = async (typeId, subTypeId, lessonPlanId) => {
    try {
      console.log(typeId, subTypeId, "get");

      if(typeId === undefined || subTypeId === undefined) return {};

      let fetchedLessons = lessonPlans.lessons;

      if (!fetchedLessons.length) {
        const { lessons, error } = await fetchLessonPlans(typeId, subTypeId);

        if (error) return {};

        fetchedLessons = lessons;
      }

      const requiredLessonPLan = fetchedLessons.find(
        (lesson) => lesson.id.toString() === lessonPlanId.toString()
      );

      if (!requiredLessonPLan) return {};

      return requiredLessonPLan;
    } catch (error) {
      console.error("Error in getLessonPlanById:", error);
      return {};
    }
  };

  const getLessonSteps = async (learnId) => {
    try {
      if (lessonSteps[learnId]?.steps?.groups?.length) {
        return lessonSteps[learnId]?.steps;
      }

      const lessonStep = {
        steps: {
          groups: [],
          name: ""
        },
        error: null,
      };

      try {
        const lessonStepsData = await ApiService.fetchLearningStepsDesktop(
          learnId
        );
        console.log(lessonStepsData.data, "lessonStepsData");

        lessonStep.steps = lessonStepsData.data;
      } catch (error) {
        console.log(error);
        lessonStep.error = error;
      }

      setLessonSteps({
        ...lessonSteps,
        [learnId]: lessonStep,
      });

      return lessonStep.steps;
    } catch (error) {
      console.error("Error in getLessonSteps:", error);
      return { groups: [], name: "" };
    }
  };

  const value = {
    getAllLessonPlans,
    getLessonPlanById,
    getLessonSteps
  };

  return (
    <LessonPlanContext.Provider value={value}>
      {children}
    </LessonPlanContext.Provider>
  );
};
